import { render, staticRenderFns } from "./form-row.vue?vue&type=template&id=40b2a8f4"
import script from "./form-row.vue?vue&type=script&lang=js"
export * from "./form-row.vue?vue&type=script&lang=js"
import style0 from "./form-row.vue?vue&type=style&index=0&id=40b2a8f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports